import React, { Component } from 'react';
import { selectAll, event } from 'd3-selection';
import _cool from 'd3-selection-multi';
import StartAudioContext from 'startaudiocontext';
import Tone from 'tone';
// basic stuff common to all game types
class GameContainer extends Component {
  componentDidMount() {
    const that = this;
    //MOVE THIS to game start
    StartAudioContext(Tone.context, "#game").then(() => {
    //if not mobile use click,
    // problem is click and touchend will both get called on mobile,
    // using just click wont support multitouch

      selectAll(".original-circles").on("touchstart click", function(ob, i) {
          event.preventDefault();
          that.props.store.playFixedAtIndex(i);
      });
      selectAll(".detuned-circles").on("touchstart click", function(ob, i) {
        event.preventDefault();
        that.props.store.selectedIndex = i;
        that.props.store.playDetunedAtIndex(i);
      });
    });

     // stop scroll bouncing
    document.addEventListener("touchmove", function(event){
      event.preventDefault();
    });
    // // stop ios safari flicker when touching outside svg, for example
    document.addEventListener("touchend", function(event) {
      //this does stop flicker but screws op onClick
      event.preventDefault();
    });
  }
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}
export default GameContainer;



// WEBPACK FOOTER //
// ./src/components/game-container.js